<template lang="pug">
.other-user-safety-confirm-answer-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // セル：登録日時
    template(#cell(created)="row")
      .d-flex.flex-column.align-items-center
        span {{ convertCreated(row.item.created) }}
    // セル：最新の登録
    template(#cell(isLatest)="row")
      .d-flex.flex-column.align-items-center
        span(:class="{ 'latest-strong': row.item.isLatest }") {{ row.item.isLatest ? 'はい' : 'いいえ' }}
    // セル：連絡事項(confirm-7) テキスト入力の場合は省略記号有り、popoverで全文表示する
    template(#cell(7)="row")
      span(:id="'confirm-7' + row.item.created") {{ row.item['7'] }}
      b-popover(:target="'confirm-7' + row.item.created" triggers="hover" placement="top")
        span {{ row.item['7'] }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 待機者テーブルコンポーネント
 */
@Component({})
export default class OtherUserSafetyConfirmAnswerTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<OtherUserSafetyConfirmAnswerTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OtherUserSafetyConfirmAnswerTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<OtherUserSafetyConfirmAnswerTableItem> {
    return this.value;
  }

  public convertCreated(created: number): string {
    if (!created) {
      return "";
    }
    return this.$dateUtil.convertNumberToString(created, "mm月dd日 hh:MM");
  }

  /**
   * ### フィルタリング
   */
  public filterTable(item: OtherUserSafetyConfirmAnswerTableItem, filter: FilterSetting): boolean {
    return (
      this.isLatest(item, filter) &&
      // 質問内容は動的項目のため質問のmasterが増える毎にfilter処理も増やす必要がある
      this.filterConfirm1(item, filter) &&
      this.filterConfirm2(item, filter) &&
      this.filterConfirm3(item, filter) &&
      this.filterConfirm4(item, filter) &&
      this.filterConfirm5(item, filter) &&
      this.filterConfirm6(item, filter) &&
      this.filterConfirm7(item, filter)
    );
  }

  public isLatest(item: OtherUserSafetyConfirmAnswerTableItem, filter: FilterSetting): boolean {
    if (filter.isLatest == false) {
      return true;
    }
    return item.isLatest;
  }

  /**
   * ### 質問id=1(本人の状況)のフィルタリング
   *
   * - ラジオ入力の場合、チェックボックスと回答コード値でフィルタリングする
   */
  public filterConfirm1(item: any, filter: FilterSetting): boolean {
    if (filter.confirm1.input0 == false && filter.confirm1.input1 == false && filter.confirm1.input2 == false) {
      return true;
    }

    if (filter.confirm1.input0 == true && item["1-value"] == 0) {
      return true;
    }
    if (filter.confirm1.input1 == true && item["1-value"] == 1) {
      return true;
    }
    if (filter.confirm1.input2 == true && item["1-value"] == 2) {
      return true;
    }

    return false;
  }
  public filterConfirm2(item: any, filter: FilterSetting): boolean {
    if (filter.confirm2.input0 == false && filter.confirm2.input1 == false && filter.confirm2.input2 == false && filter.confirm2.input3 == false) {
      return true;
    }

    if (filter.confirm2.input0 == true && item["2-value"] == 0) {
      return true;
    }
    if (filter.confirm2.input1 == true && item["2-value"] == 1) {
      return true;
    }
    if (filter.confirm2.input2 == true && item["2-value"] == 2) {
      return true;
    }
    if (filter.confirm2.input3 == true && item["2-value"] == 3) {
      return true;
    }

    return false;
  }
  public filterConfirm3(item: any, filter: FilterSetting): boolean {
    if (filter.confirm3.input0 == false && filter.confirm3.input1 == false && filter.confirm3.input2 == false && filter.confirm3.input3 == false) {
      return true;
    }

    if (filter.confirm3.input0 == true && item["3-value"] == 0) {
      return true;
    }
    if (filter.confirm3.input1 == true && item["3-value"] == 1) {
      return true;
    }
    if (filter.confirm3.input2 == true && item["3-value"] == 2) {
      return true;
    }
    if (filter.confirm3.input3 == true && item["3-value"] == 3) {
      return true;
    }

    return false;
  }
  public filterConfirm4(item: any, filter: FilterSetting): boolean {
    if (filter.confirm4.input0 == false && filter.confirm4.input1 == false && filter.confirm4.input2 == false && filter.confirm4.input3 == false) {
      return true;
    }

    if (filter.confirm4.input0 == true && item["4-value"] == 0) {
      return true;
    }
    if (filter.confirm4.input1 == true && item["4-value"] == 1) {
      return true;
    }
    if (filter.confirm4.input2 == true && item["4-value"] == 2) {
      return true;
    }
    if (filter.confirm4.input3 == true && item["4-value"] == 3) {
      return true;
    }

    return false;
  }
  public filterConfirm5(item: any, filter: FilterSetting): boolean {
    if (filter.confirm5.input0 == false && filter.confirm5.input1 == false && filter.confirm5.input2 == false && filter.confirm5.input3 == false) {
      return true;
    }

    if (filter.confirm5.input0 == true && item["5-value"] == 0) {
      return true;
    }
    if (filter.confirm5.input1 == true && item["5-value"] == 1) {
      return true;
    }
    if (filter.confirm5.input2 == true && item["5-value"] == 2) {
      return true;
    }
    if (filter.confirm5.input3 == true && item["5-value"] == 3) {
      return true;
    }

    return false;
  }

  public filterConfirm6(item: any, filter: FilterSetting): boolean {
    if (
      filter.confirm6.input0 == false &&
      filter.confirm6.input1 == false &&
      filter.confirm6.input2 == false &&
      filter.confirm6.input3 == false &&
      filter.confirm6.input4 == false &&
      filter.confirm6.input5 == false &&
      filter.confirm6.input6 == false
    ) {
      return true;
    }

    if (filter.confirm6.input0 == true && item["6-value"] == 0) {
      return true;
    }
    if (filter.confirm6.input1 == true && item["6-value"] == 1) {
      return true;
    }
    if (filter.confirm6.input2 == true && item["6-value"] == 2) {
      return true;
    }
    if (filter.confirm6.input3 == true && item["6-value"] == 3) {
      return true;
    }
    if (filter.confirm6.input4 == true && item["6-value"] == 4) {
      return true;
    }
    if (filter.confirm6.input5 == true && item["6-value"] == 5) {
      return true;
    }
    if (filter.confirm6.input6 == true && item["6-value"] == 6) {
      return true;
    }

    return false;
  }

  /**
   * ### 質問id=7(連絡事項)のフィルタリング
   *
   * - テキスト入力の場合、入力有／無のみでフィルタリングする
   */
  public filterConfirm7(item: any, filter: FilterSetting): boolean {
    if (filter.confirm7.isInput == false) {
      return true;
    }
    if (item["7"]) {
      return true;
    }
    return false;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }
}

/** テーブルの列名の情報 */
export interface OtherUserSafetyConfirmAnswerTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/**
 * ### テーブルの1行あたりの情報
 *
 * - 質問内容についてはidのプロパティが動的に追加されるので定義しない
 *   - valueと文字列のペアになっている
 *   - 例：質問ID=1の場合、プロパティ名「1」に文字列、「1-value」にコード値が格納される
 */
export interface OtherUserSafetyConfirmAnswerTableItem {
  /** 施設関係者グループ名 */
  groupName: string;
  /** 施設関係者ユーザー名 */
  groupMemberName: string;
  /** 所属 */
  groupMemberOrganization: string;
  /** 電話番号 */
  groupMemberTel: string;
  /** 登録日時 */
  created: number;
  /** 最新の登録 */
  isLatest: boolean;
}

/**
 * ### フィルタリング情報
 *
 * - 質問内容についてはmasterのidが増えるたびに定義を増やす必要がある
 */
export interface FilterSetting {
  /** 最新か否か */
  isLatest: boolean;
  /** 本人の状況:質問1 */
  confirm1: {
    /** 無事 */
    input0: boolean;
    /** 軽傷 */
    input1: boolean;
    /** 重傷 */
    input2: boolean;
  };
  /** 同居家族の状況:質問2 */
  confirm2: {
    /** 同居家族無し */
    input0: boolean;
    /** 全員無事 */
    input1: boolean;
    /** 負傷者有り */
    input2: boolean;
    /** 不明 */
    input3: boolean;
  };
  /** 住居の状況:質問3 */
  confirm3: {
    /** 無事 */
    input0: boolean;
    /** 一部倒壊 */
    input1: boolean;
    /** 倒壊 */
    input2: boolean;
    /** 不明 */
    input3: boolean;
  };
  /** 現在の居場所:質問4 */
  confirm4: {
    /** 自宅 */
    input0: boolean;
    /** 施設内・会社内 */
    input1: boolean;
    /** 移動中 */
    input2: boolean;
    /** その他 */
    input3: boolean;
  };
  /** 出社可否:質問5 */
  confirm5: {
    /** 既に出社 */
    input0: boolean;
    /** 出社可能 */
    input1: boolean;
    /** 不可能 */
    input2: boolean;
    /** その他 */
    input3: boolean;
  };
  /** 出社見込み時間:質問6 */
  confirm6: {
    /** 既に出社 */
    input0: boolean;
    /** 30分以内 */
    input1: boolean;
    /** 1時間以内 */
    input2: boolean;
    /** 2時間以内 */
    input3: boolean;
    /** 3時間以内 */
    input4: boolean;
    /** 6時間以内 */
    input5: boolean;
    /** 不明、出社不可 */
    input6: boolean;
  };
  /** 連絡事項:質問7 */
  confirm7: {
    // テキスト入力は入力されているか否かのboolean
    isInput: boolean;
  };
}
</script>
